<script>
import Title from '@components/section-title'
import Vue from 'vue'
import store from '@state/store'
import {
  getNumber,
  getDataCotizacao,
  getCorretoraSimple,
  toMoney,
} from '@utils/Format'
import { resgateTotal, aporte } from '@constants/URL'
import { mask } from 'vue-the-mask'
import rules from '@constants/Rules'
import { masks } from '@constants/Masks'
import { GlobalBus } from '@services/bus'
import { MODAL, RELOAD, ACTION } from '@constants/Text'
import con from '@connection'
import moment from 'moment'

export default {
  directives: {
    mask,
  },
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      assets: [],
      loading: false,
      rules: rules,
      masks: masks,
      loadingAssets: {},
      dataResgate: {},
      dataCotizacao: {},
      preco_unitario: {},
      saldo_conta: false,
    }
  },
  computed: {
    id_cliente() {
      return (
        this.$route.params.id_cliente ||
        (store.getters['user/currentClient'] || { id: '' }).id
      )
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.RESGATE_TOTAL, this.open)
    }
    this.busModal.$on('close', this.onClose)
    GlobalBus.$on(ACTION.MERGED_ASSET, this.mergedAsset)
  },
  beforeDestroy() {
    if (this.bus) {
      this.bus.$off(MODAL.RESGATE_TOTAL, this.open)
    }
    this.busModal.$off('close', this.onClose)
    GlobalBus.$off(ACTION.MERGED_ASSET, this.mergedAsset)
  },
  methods: {
    open(assets) {
      window.SHOW_AUTOMATIC_RESCUE = false
      this.clear()
      if (assets.length) {
        this.assets = assets
        this.assets.forEach((v, i) => {
          this.dataResgate[v.nome_ativo] = ''
          this.dataCotizacao[v.nome_ativo] = ''
          this.preco_unitario[v.nome_ativo] = 0
        })
      } else {
        this.getAssets()
      }
      this.busModal.$emit('dialog', true)
    },
    onClose() {
      GlobalBus.$emit(RELOAD.ASSETS)
    },
    getCorretoras(corretora) {
      return getCorretoraSimple(corretora)
    },
    toMoney(d) {
      return toMoney(d)
    },
    getAssets() {
      if (this.loading) {
        return
      }
      this.loading = true
      let url
      if (this.usuarioAtual.IS_CLIENTE) {
        url = resgateTotal.resgate_total_contas_automaticas
      } else {
        url = resgateTotal.professional.resgate_total_contas_automaticas
      }
      con.get(url).then((res) => {
        if (res.status === 200) {
          this.assets = res.value
          this.assets.forEach((v, i) => {
            this.dataResgate[v.nome_ativo] = ''
            this.dataCotizacao[v.nome_ativo] = ''
            this.preco_unitario[v.nome_ativo] = 0
          })
        } else {
          this.assets = []
        }
        this.loading = false
      })
    },
    async remover(ativo) {
      if (this.loadingAssets[ativo.id]) {
        return
      }
      const data = {
        id_cliente: this.id_cliente,
        id_ativo: ativo['id'],
      }
      this.$set(this.loadingAssets, ativo.id, 'remove')
      let url
      if (this.usuarioAtual.IS_CLIENTE) {
        url = resgateTotal.remover
      } else {
        url = resgateTotal.professional.remover
      }
      const r = await con.post(url, data) //
      if (r.status === 200) {
        this.hideAsset(ativo)
      } else {
        this.$set(this.loadingAssets, ativo.id, '')
      }
      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    hideAsset(ativo) {
      setTimeout(() => {
        this.assets = this.assets.filter((v, i) => {
          return v.id !== ativo.id
        })

        if (!this.assets.length) {
          this.busModal.$emit('dialog', false)
          GlobalBus.$emit(RELOAD.ASSETS)
        }

        this.$set(this.loadingAssets, ativo.id, '')
      }, 2000)
    },
    async sendResgateTotal(ativo, text_loading = 'salvar') {
      if (this.loadingAssets[ativo.id]) {
        return
      }
      if (
        !this.dataResgate[ativo.nome_ativo] ||
        !this.dataCotizacao[ativo.nome_ativo] ||
        (!this.preco_unitario[ativo.nome_ativo] &&
          ['FII', 'Ações', 'Ação'].includes(ativo.tipo || ativo.Tipo))
      ) {
        return
      }
      this.$set(this.loadingAssets, ativo.id, text_loading)
      this.loading = true
      let data = {
        id_cliente_app: this.id_cliente,
        id_conta: ativo.id_conta,
        nome_ativo: ativo.nome_ativo,
        valor: 0,
        quantidade: ativo.qtd || ativo.quantidade || 1,
        valor_unitario: getNumber(
          this.preco_unitario[ativo.nome_ativo] || ativo.pu || 0
        ),
        data_aplicacao: this.dataResgate[ativo.nome_ativo],
        data_cotizacao: this.dataCotizacao[ativo.nome_ativo],
        id: ativo.id,
        resgate_total: 1,
        id_aplicacao: ativo.id_aplicacao || null,
      }

      let url
      if (this.usuarioAtual.IS_CLIENTE) {
        url = aporte.client.add
      } else {
        url = aporte.professional.manage_add
      }
      const res = await con.post(url, data)
      if (res.status === 200) {
        this.$showSnack({
          text: 'Resgate total realizado com sucesso',
          button: true,
        })
        this.hideAsset(ativo)
      } else {
        this.$set(this.loadingAssets, ativo.id, '')
        this.$showSnack({
          text: res.message,
          button: true,
        })
      }

      this.loading = false
    },
    async coletarDataCotizacao(ativo) {
      if ((this.dataResgate[ativo.nome_ativo] || '').length === 10) {
        this.dataCotizacao[ativo.nome_ativo] = (await getDataCotizacao(
          this.dataResgate[ativo.nome_ativo],
          'Resgatar',
          ativo.referencia
        ))
          ? await getDataCotizacao(
              this.dataResgate[ativo.nome_ativo],
              'Resgatar',
              ativo.referencia
            )
          : (this.dataCotizacao[ativo.nome_ativo] = moment(
              this.dataResgate[ativo.nome_ativo],
              'DD/MM/YYYY'
            )
              .add(1, 'day')
              .format('DD/MM/YYYY'))
      }
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    openVincular(origem) {
      this.$set(this.loadingAssets, origem.id, 'vincular')
      GlobalBus.$emit(MODAL.VINCULAR_ATIVO_ESCOLHER, {
        origem: origem,
        id_cliente: this.id_cliente,
      })
    },
    mergedAsset(asset) {
      this.hideAsset(asset)
    },
    clear() {
      this.dataResgate = {}
      this.dataCotizacao = {}
      this.assets = []
      this.loadingAssets = {}
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal max-width="100%" height="800px" :bus="busModal">
    <div v-if="!loading" style="margin-bottom: 20px">
      <Title title="Resgate total" />

      <p class="mb-0">
        Os ativos abaixo não foram encontrados em sua carteira na instituição
        atualizada. Caso não tenha realizado o resgate dos ativos, apenas
        ignore.
      </p>
      <p>
        Caso tenha realizado o resgate, por favor, inserir a data de realização
        do resgate total:
      </p>

      <v-simple-table
        v-if="assets.length > 0"
        ref="table-ativos-aceitar"
        key="tabela-ativos-aceitar"
        style="width: 100%"
        fixed-header
      >
        <template v-slot>
          <thead>
            <tr>
              <th class="text-left" style="max-width: 300px">Ativo</th>
              <th class="text-left">Corretora</th>
              <!-- <th>Investido</th> -->
              <th colspan="3"></th>
              <!-- <th colspan="3"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(ativo, index) in assets"
              :key="ativo.nome_ativo + index"
            >
              <td class="text-left" style="max-width: 300px">
                {{ ativo.nome_ativo || '—' }}
              </td>
              <td class="text-left"> {{ getCorretoras(ativo.corretora) }} </td>
              <!-- <td class="text-center">
                {{ toMoney(ativo.aplicacao_inicial) }}
              </td> -->
              <td class="text-left">
                <v-form>
                  <v-text-field
                    :key="ativo.nome_ativo + index"
                    v-model="dataResgate[ativo.nome_ativo]"
                    v-mask="masks.data"
                    label="Data do resgate*"
                    dense
                    :rules="[rules.required, rules.data]"
                    @keyup="coletarDataCotizacao(ativo)"
                  ></v-text-field>
                </v-form>
              </td>
              <td>
                <v-form
                  v-if="
                    ['FII', 'Ações', 'Ação'].includes(ativo.tipo || ativo.Tipo)
                  "
                >
                  <v-currency-field
                    v-model="preco_unitario[ativo.nome_ativo]"
                    prefix="R$ "
                    label="Preço Unitário*"
                    :rules="[rules.required]"
                  />
                </v-form>
                <div
                  v-if="
                    ['Renda Fixa', 'Tesouro Direto'].includes(
                      ativo.tipo || ativo.Tipo
                    )
                  "
                  style="width: 100%; display: flex"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        :loading="loadingAssets[ativo.id] === 'vencimento'"
                        primary
                        small
                        outline
                        style="margin: auto"
                        @click="sendResgateTotal(ativo, 'vencimento')"
                        v-on="on"
                      >
                        <v-icon small style="color: inherit">
                          mdi-calendar-alert
                        </v-icon>
                        Ativo vencido
                      </BaseButton>
                    </template>
                    <span>
                      Se o ativo venceu, informe a data de vencimento.
                    </span>
                  </v-tooltip>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-center">
                  <v-tooltip bottom class="mr-2">
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        :loading="loadingAssets[ativo.id] === 'salvar'"
                        primary
                        small
                        @click="sendResgateTotal(ativo)"
                        v-on="on"
                      >
                        <v-icon small style="color: inherit">
                          mdi-download-outline
                        </v-icon>
                        Resgatar
                      </BaseButton>
                    </template>
                    <span>
                      Se você realizou o resgate do ativo,
                      <br />
                      informe a data que foi realizado.
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        :loading="loadingAssets[ativo.id] === 'remove'"
                        dark
                        small
                        outline
                        @click="remover(ativo)"
                        v-on="on"
                      >
                        <v-icon small style="color: inherit">
                          mdi-close
                        </v-icon>
                        Ignorar
                      </BaseButton>
                    </template>
                    <span>
                      Caso não tenha realizado o resgate,
                      <br />
                      apenas ignore a sugestão.
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="$isWhitelabel() || $currentUser().IS_CLIENTE"
                    bottom
                    class="ml-2"
                  >
                    <template v-slot:activator="{ on }">
                      <BaseButton
                        :loading="loadingAssets[ativo.id] === 'vincular'"
                        primary
                        small
                        outline
                        @click="openVincular(ativo)"
                        v-on="on"
                      >
                        <v-icon small style="color: inherit"> mdi-link </v-icon>
                        Vincular
                      </BaseButton>
                    </template>
                    <span> Vincular à outro ativo da carteira. </span>
                  </v-tooltip>
                </div>
              </td>
              <!-- <td class="text-left">
                <v-checkbox
                  label="Transferir para saldo em conta"
                  v-model="saldo_conta"
                ></v-checkbox>
              </td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <v-row v-if="loading" justify="center" align="center">
      <div class="text-center ma-12 w-100">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-row>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Continuar </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


